import { AppModules } from 'appContainer/types';
import { isAddSlideFromCurrentViewModule } from 'appContainer/presentationEditorModules';
import { trackClickedToolbarButton } from 'tracking/events/clicks';
import { dispatchAction } from '@ardoq/rxbeach';
import { togglePresentationEditor } from 'appContainer/actions';
import { trackOpenedPresentationSidebar } from 'presentation/tracking';
import { openPresentationPicker } from 'presentationEditor/presentationPicker/actions';
import { ArdoqId } from '@ardoq/api-types';

type ShowPresentationEditorArgs = {
  contextPresentationId?: ArdoqId;
  selectedModule: AppModules;
  shouldShow: boolean;
};
export const showPresentationEditor = ({
  contextPresentationId,
  selectedModule,
  shouldShow,
}: ShowPresentationEditorArgs): void => {
  trackClickedToolbarButton('Presentation editor');

  if (!contextPresentationId) {
    dispatchAction(
      openPresentationPicker({
        intent: 'openPresentation',
        isOpeningPresentationEditorToAddSlideFromCurrentView:
          isAddSlideFromCurrentViewModule(selectedModule),
      })
    );
    return;
  }

  if (shouldShow) {
    trackOpenedPresentationSidebar(
      'Presentation browser',
      contextPresentationId
    );
  }

  dispatchAction(togglePresentationEditor({ shouldShow }));
};
